module.exports = __webpack_public_path__ + "static/media/slider1.6549601b.jpg";